import {
  ICandidate,
  ITag,
  INote,
  IApplicationClickInfo,
  IApplication,
} from '../../../interfaces/graph-types';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CandidateService } from '../../../services/candidate.service';
import { Subject, Observable } from 'rxjs';
import { WatchAccountService } from '../../../services/watch-account.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalFunnelSelectorComponent } from '../../modals/funnel-selector/modal-funnel-selector.component';
import { AccountService } from '../../../services/account.service';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'application-info',
  template: require('./application-info.component.pug'),
  styles: [require('./application-info.component.css').toString()],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationInfoComponent implements OnInit {
  @Input()
  applicationSubjectId: Subject<string>;

  @Input()
  accountId: string;
  @Output()
  onClose = new EventEmitter();
  @Output()
  onApplicationDelete = new EventEmitter();

  application: IApplication = null;
  companyId$: Subject<string>;

  sub: any = null;
  prosub: any = null;

  rightPercent = '-65%';
  backdrop = 'none';
  phone = null;

  bsModalRef: BsModalRef;

  addNoteForm: FormGroup;
  errorNoteMessage?: string;
  isUpdating = false;

  notes$: Observable<INote[]>;

  emailVerificationOptions = {
    '-1': {
      value: 'invalid',
      tooltip: 'Email has been flagged as invalid',
      class: { 'badge-danger': true },
    },
    '1': {
      value: 'valid',
      tooltip: 'Email has been flagged as valid',
      class: { 'badge-success': true },
    },
    '2': {
      value: 'risky',
      tooltip: 'Email has been flagged as risky. Send at your own risk.',
      class: { 'badge-warning': true },
    },
    '3': {
      value: 'unknown validity',
      tooltip: 'Email address validity is unknown',
      class: { 'badge-dark': true },
    },
  };

  // -------------------------------------------------------------------
  constructor(
    private candidateService: CandidateService,
    private accountService: AccountService,
    private watchAccount: WatchAccountService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) {
    this.companyId$ = new Subject<string>();
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.addNoteForm = this.formBuilder.group({
      content: '',
    });

    this.sub = this.applicationSubjectId.subscribe(newApplicationId => {

      if (newApplicationId == null) {
        this.rightPercent = '-65%';
        this.backdrop = 'none';
      } else {
        this.application = null;
        if (this.prosub) {
          this.prosub.unsubscribe();
        }
        this.prosub = this.candidateService
          .getApplicationInfo(newApplicationId)
          .subscribe(response => {
            this.application = response;
            // this.cdr.detectChanges();
          });

        this.rightPercent = '0%';
        this.backdrop = 'block';
      }
      // this.cdr.detectChanges(); // to enable sliding window to be VRDisplayCapabilities, otherwise we'll have to wait the return from the server to slide the window
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.prosub) {
      this.prosub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  clickclose() {
    this.applicationSubjectId.next(null);

    if (this.onClose) {
      this.onClose.emit();
    }
  }

  // -------------------------------------------------------------------
  public timeDelay(created, updated){

    let date1 = new Date(created);
    let date2 = new Date(updated);

    let diffTime = Math.abs(+date2 - +date1);

    let sec =  Math.ceil(diffTime / 1000);
    if (sec <= 90) return sec.toString() + "sec.";;

    let min =  Math.ceil(diffTime / (1000 * 60));
    if (min <= 90) return min.toString() + "min.";

    let hour =  Math.ceil(diffTime / (1000 * 60 * 60));
    if (hour <= 48) return hour.toString() + "hour.";

    let day =  Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return day.toString() + "day.";
  }

  // -------------------------------------------------------------------
  public getExplanation(json) {
    let explanation = JSON.parse(json).explanation;
    if (explanation) return "> " + explanation;
    return "";
  }

  // -------------------------------------------------------------------
  public getChoices(json){
    return JSON.parse(json).items
  }

  // -------------------------------------------------------------------
  public getScore(name, choices){
    let jchoices = JSON.parse(choices);

    const result = jchoices.find( item => item.value === name );

    if (!result) return 0;

    return result.score;
  }

  // -------------------------------------------------------------------
  mouseEnter(day, index) {}

  // -------------------------------------------------------------------
  mouseLeave() {}

}
